// import $ from 'jquery';

// // Multi-Step Form

// // Current tab and variables
// let currentTab = 0;
// const tabs = $('.tab');
// const steps = $('.step');

// // Show the starting tab
// showTab(currentTab);

// // Function to display the specified tab
// function showTab(n) {
//     // Hide Previous Tab
//     tabs.eq(n).removeClass('hidden');
//     tabs.eq(n).addClass('block');

//     steps.eq(n).removeClass('bg-equity-secondary').addClass('bg-equity-primary');

//     if (n === 0) {
//         $('#prevBtn').hide();
//     } else {
//         $('#prevBtn').show();
//     }

//     if (n === tabs.length - 1) {
//         $('#nextBtn').text('Submit');
//     } else {
//         $('#nextBtn').text('Next');
//     }
// }

// // Function to handle next/previous buttons
// function nextPrev(n) {
//     if (!validateForm()) return;

//     tabs.eq(currentTab).removeClass('block');
//     tabs.eq(currentTab).addClass('hidden');

//     steps.eq(currentTab + n).toggleClass('bg-equity-secondary bg-equity-primary');
//     steps.eq(currentTab).removeClass('bg-equity-primary').addClass('bg-equity-secondary');

//     currentTab += n;

//     if (currentTab >= tabs.length) {
//         $('#regForm').submit();
//         return false;
//     }

//     showTab(currentTab);
// }

// $(function(){

//     $('#regForm').validate({
//         rules:{
//         version: "required",
//         type: "required",
//         numSelect: "required",
//         userNums: "required"
//       }
//     });
//   });

// Function to validate form fields
// function validateForm() {
//       var rules = {
//             first_name: "required",
//             last_name: "required",
//             email: {
//                 required: true,
//                 email: true
//             },
//             password: {
//                 required: true,
//                 minlength: 5
//             },
//             confirm_password: {
//                 required: true,
//                 minlength: 5,
//                 equalTo: "#password"
//             },
//             address: "required",
//             city: "required",
//             zipcode: "required",
//             country: "required",
//             agree: "required"
//         };
//         var messages = {
//             first_name: "Please enter your first name",
//             last_name: "Please enter your last name",
//             email: "Please enter a valid email address",
//             password: {
//                 required: "Please provide a password",
//                 minlength: "Your password must be at least 5 characters long"
//             },
//             confirm_password: {
//                 required: "Please confirm password",
//                 minlength: "Your password must be at least 5 characters long",
//                 equalTo: "Please enter the same password as above"
//             },
//             address: "Please enter your address",
//             city: "Please enter your city",
//             zipcode: "Please enter your zipcode",
//             country: "Please select your country",
//             agree: "Please accept our policy"
//         };

//     let valid = true;
//     const inputs = tabs.eq(currentTab).find('input');

//     inputs.each(function () {
//         //var validator = $('#regForm').validate();
//         // validator.element( "#EmailAddress" );
//         if ($(this).val() === '' ) {
//             $('#error-'+$(this).attr('name')).removeClass('hidden');
//             $(this).addClass('invalid');
//             valid = false;
//         }else{
//             $('#error-'+$(this).attr('name')).addClass('hidden');
//         }
//     });

//     if (valid) {
//         $('.step').eq(currentTab).addClass('finish');
//     }

//     return valid;
// }

//select multiple
// const element = document.getElementById("selectcountries");
// element.onchange = function() {
//     let list = document.getElementById("select2-selectcountries-container").children;
//     let countries = [];
//     for (let i = 0; i < list.length; i++) {
//         countries.push(list[i].title);
//     }

//     if (countries.includes("Other") || countries.includes("Autre") || countries.includes("Nyingine") || countries.includes("Ikindi")) {
//         document.getElementById("othercountry").classList.remove("d-none");
//         document.getElementById("othercountry").classList.add("d-block");
//     } else {
//         document.getElementById("othercountry").classList.add("d-none");
//         document.getElementById("othercountry").classList.remove("d-block");
//     }
// };

// const expert = document.getElementById("expertise");
// expert.onchange = function() {
//     // let list = document.getElementById("select2-selectcountries-container").children;
//     // let countries = [];
//     // for(let i = 0;  i < list.length; i++){
//     //     countries.push(list[i].title);
//     // }

//     if (expert.value == "other" || expert.value == "autre" || expert.value == "nyingine" || expert.value == "ikindi") {
//         document.getElementById("otherexpert").classList.remove("d-none");
//     document.getElementById("otherexpert").classList.add("d-block");
//     document.getElementsByName("otherexpert")[0].required = true;
//     } else {
//         document.getElementById("otherexpert").classList.add("d-none");
//     document.getElementById("otherexpert").classList.remove("d-block");
//      document.getElementsByName("otherexpert")[0].required = false;

//     }
// };

// const interest = document.getElementById("interestarea");
//  interest.onchange = function() {

//     if (interest.value == "other" || expert.value == "autre" || expert.value == "nyingine" || expert.value == "ikindi") {
//         document.getElementById("otherinterest").classList.remove("d-none");
//     document.getElementById("otherinterest").classList.add("d-block");
//      document.getElementsByName("otherinterest")[0].required = true;
//     } else {
//         document.getElementById("otherinterest").classList.add("d-none");
//     document.getElementById("otherinterest").classList.remove("d-block");
//      document.getElementsByName("otherinterest")[0].required = false;
//     }
// };



//  const invtitle = document.getElementById("title");
// invtitle.onchange = function() {

//     if (invtitle.value == "Other" || expert.value == "autre" || expert.value == "nyingine" || expert.value == "ikindi") {
//         document.getElementById("othertitle").classList.remove("d-none");
//     document.getElementById("othertitle").classList.add("d-block");
//      document.getElementsByName("othertitle")[0].required = true;
//     } else {
//         document.getElementById("othertitle").classList.add("d-none");
//     document.getElementById("othertitle").classList.remove("d-block");
//      document.getElementsByName("othertitle")[0].required = false;
//     }
// };


// const invposition = document.getElementById("position");
// invposition.onchange = function() {

//     if (invposition.value == "other" || expert.value == "autre" || expert.value == "nyingine" || expert.value == "ikindi") {
//         document.getElementById("otherposition").classList.remove("d-none");
//     document.getElementById("otherposition").classList.add("d-block");
//      document.getElementsByName("otherposition")[0].required = true;
//     } else {
//         document.getElementById("otherposition").classList.add("d-none");
//     document.getElementById("otherposition").classList.remove("d-block");
//      document.getElementsByName("otherposition")[0].required = true;
//     }
// };

// const insured = document.getElementById("insured");
// insured.onchange = function() {

//     if (insured.value == "No") {
//         document.getElementById("getinsuredd").classList.remove("d-none");
//         document.getElementById("getinsuredd").classList.add("d-block");
//     } else {
//         document.getElementById("getinsuredd").classList.add("d-none");
//         document.getElementById("getinsuredd").classList.remove("d-block");
//     }
// };

// var selections = {};
// var checkboxElems = document.getElementsByName("triptype");
// var totalElem = document.getElementById("totalcost");

// for (var i = 0; i < checkboxElems.length; i++) {
// checkboxElems[i].addEventListener("click", displayCheck);
// }



// function displayCheck(e) {
// if (e.target.checked) {
//     selections[e.target.id] = {
//     name: e.target.name,
//     value: e.target.value,
//     cost: e.target.dataset.cost
//     };
//     console.log(selections);

//     if(e.target.id == 'fulltrip'){
//         document.getElementById('nbokin').checked = false;
//         document.getElementById('nbokin').disabled = true;
//         document.getElementById('kinlb').checked = false;
//         document.getElementById('kinlb').disabled = true;
//         document.getElementById('lbnbo').checked = false;
//         document.getElementById('lbnbo').disabled = true;
//     }
// } 
// else {
//     if(e.target.id == 'fulltrip'){
//         document.getElementById('kinlb').disabled = false;
//         document.getElementById('lbnbo').disabled = false;
//         document.getElementById('nbokin').disabled = false;
//     }

//     delete selections[e.target.id];
//     console.log(selections);
// }

// var result = [];
// var total = 0;

// for (var key in selections) {
//     var listItem = selections[key].value + ", ";
//     result.push(listItem);
//     total = total + parseInt(selections[key].cost);
// }

// if(total >= 1810){
//     total = 1810;
// }
// document.getElementById('mypackage').value = result;
// document.getElementById('mytripcost').value = total;

// document.getElementById('tripchoosen').value = result;
// document.getElementById('elqtripcost').value = total;

// document.getElementById('tripcost').value = total;
// document.getElementById('flightcost').innerHTML = 'USD <b>' + total + '</b>';

// totalElem.innerHTML = 'USD <b>' + total + '</b>';
// }

// Bind click events to buttons
$('#nextBtn').click(function () {
    nextPrev(1);
});

$('#prevBtn').click(function () {
    nextPrev(-1);
});


